import gql from 'graphql-tag';
import { SAVED_LISTING } from './SavedListing.fragment';

export const SAVED_PROPERTIES_QUERY = gql`
    query getSavedProperties($first: Int, $after: ID, $last: Int, $before: ID) {
        savedProperties(
            first: $first
            after: $after
            last: $last
            before: $before
        ) {
            ... on SavedPropertyListResult {
                listings {
                    creationDate
                    listing {
                        ...SAVED_LISTING
                    }
                }
                listingIds
            }
            ... on SavedPropertyListInvalidInputError {
                errorCode
            }
        }
    }

    ${SAVED_LISTING}
`;

export const DELETE_SAVED_PROPERTIES_MUTATION = gql`
    mutation deleteUserListings($listingIds: [Int!]!) {
        deleteUserListings(listingIds: $listingIds) {
            ... on SavedListingUpdateResultSuccess {
                successCode
            }

            ... on SavedListingUpdateInvalidInputError {
                errorCode
            }
        }
    }
`;
